const camelCaseToParamCase = input => {
  return input.replace(/[A-Z]/g, match => {
    return "-".concat(match.toLowerCase());
  });
};
const buildURL = (url, params) => {
  const instance = new URL(url);
  for (const camelCasedParamKey in params) {
    const paramKey = camelCaseToParamCase(camelCasedParamKey);
    const paramValue = params[camelCasedParamKey];
    if (paramValue === void 0) {
      instance.searchParams.delete(paramKey);
    } else if (Array.isArray(paramValue)) {
      instance.searchParams.set(paramKey, paramValue.join(","));
    } else {
      instance.searchParams.set(paramKey, "".concat(paramValue));
    }
  }
  const s = instance.searchParams.get("s");
  if (s) {
    instance.searchParams.delete("s");
    instance.searchParams.append("s", s);
  }
  return instance.toString();
};
const buildPixelDensitySrcSet = (url, _ref) => {
  let {
    pixelDensities,
    ...params
  } = _ref;
  return pixelDensities.map(dpr => {
    return "".concat(buildURL(url, {
      ...params,
      dpr
    }), " ").concat(dpr, "x");
  }).join(", ");
};
const buildWidthSrcSet = (url, _ref2) => {
  let {
    widths,
    ...params
  } = _ref2;
  return widths.map(width => {
    return "".concat(buildURL(url, {
      ...params,
      w: void 0,
      width
    }), " ").concat(width, "w");
  }).join(", ");
};
class Client {
  constructor(options) {
    this.baseURL = options.baseURL;
  }
  buildURLForPath(path) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return buildURL("".concat(new URL(path, this.baseURL)), params);
  }
  buildWidthSrcSetForPath(path, params) {
    return buildWidthSrcSet("".concat(new URL(path, this.baseURL)), params);
  }
  buildPixelDensitySrcSetForPath(path, params) {
    return buildPixelDensitySrcSet("".concat(new URL(path, this.baseURL)), params);
  }
}
export { Client, buildPixelDensitySrcSet, buildURL, buildWidthSrcSet };